// useOverlayPalette.js
// One-line theming for overlay pages: subscribes to config/stream, resolves
// the active event theme (URL ?theme= override → overlayTheme preset →
// overlayPalette custom keys), and applies the --jop-* custom properties to
// document.documentElement. Cleans up on change/unmount so removing a theme
// snaps back to brand defaults from index.css.
//
// Safe at document level: every /overlay/* route IS the whole document (OBS
// browser source, booth TV, or a previewer iframe — its own document either way).
import { useEffect } from "react";
import useStreamConfig from "./useStreamConfig";
import { resolveOverlayPalette, paletteToCssVars } from "../utils/overlayTheme";

export default function useOverlayPalette() {
  const config = useStreamConfig();
  const palette = resolveOverlayPalette(config);
  // Stable key so the effect only re-runs when resolved colors actually change.
  const paletteKey = JSON.stringify(palette);

  useEffect(() => {
    const vars = paletteToCssVars(JSON.parse(paletteKey));
    const root = document.documentElement;
    for (const [name, value] of Object.entries(vars)) {
      root.style.setProperty(name, value);
    }
    return () => {
      for (const name of Object.keys(vars)) {
        root.style.removeProperty(name);
      }
    };
  }, [paletteKey]);
}
